import type { WorkPeriodNode } from '../types.graphql'
import type { SalaryDayForm } from '@/modules/activities/components/overview/SalaryDayPrompt'
import { SalaryDayPrompt } from '@/modules/activities/components/overview/SalaryDayPrompt'
import { usePrompt } from '@ur-solutions/react-components'
import { useSalaryDayMutations } from '@/modules/activities/mutations.hooks'
import { TextAndAction } from './TextAndAction'
import { useTranslate } from '@ur-solutions/react-hooks'
import type { SalaryDayNode } from '@/modules/activities'

const PartOfDayMapping = {
  1: '1',
  0.75: '3/4',
  0.5: '1/2',
  0.25: '1/4',
} as { [key: number]: string }

export const SalaryDayButton: React.FC<{
  workPeriod?: Pick<WorkPeriodNode, 'id'>
  salaryDay?: Pick<SalaryDayNode, 'partOfDay' | 'salaryCode'> | null
  userId: string
  canEdit?: boolean
  border?: boolean
  restrictWidth?: boolean
  onChange?: () => void
}> = ({
  workPeriod,
  salaryDay,
  userId,
  canEdit,
  border,
  restrictWidth,
  onChange,
}) => {
  const translations = useTranslate({
    salaryDay: 'common.salary-day',
  })
  const addPrompt = usePrompt()
  const salaryDayMutations = useSalaryDayMutations()

  async function handleEditSalaryDay() {
    const { data } = await addPrompt<SalaryDayForm | null>(resolve => (
      <SalaryDayPrompt
        initialData={{
          userId: userId,
          salaryCodeId: salaryDay?.salaryCode?.id ?? null,
          partOfDay: salaryDay?.partOfDay ?? 1,
        }}
        onSubmit={resolve}
      />
    ))
    if (data === null) return

    void salaryDayMutations
      .updateOrCreateSalaryDay({
        variables: {
          input: {
            ...data,
            workPeriod: workPeriod?.id ?? null,
          },
        },
      })
      .then(() => onChange?.())
  }
  return (
    <TextAndAction
      text={translations.salaryDay}
      actionText={
        salaryDay
          ? `${PartOfDayMapping[salaryDay.partOfDay ?? 0]} ${
              salaryDay.salaryCode?.name ?? ''
            }`
          : undefined
      }
      border={border}
      onClick={canEdit ? handleEditSalaryDay : () => {}}
      restrictWidth={restrictWidth}
    />
  )
}
